import { registry, instancePerContainerCachingFactory } from 'tsyringe';
import {
  kNameOfPromotionWindowService,
  IPromotionWindowService,
} from '../../shared/interfaces/promotion-window-service.interface';
import {
  kNameOfTesterWindowService,
  ITesterWindowService,
} from '../../shared/interfaces/tester-window-service.interface';
import {
  kNameOfUserActionService,
  IUserActionService,
} from '../../shared/interfaces/user-action-service.interface';
import {
  kDITokenExternalService,
  IExposableService,
} from '../services/external-services-exposer.service';
import { PromotionWindowService } from '../services/promotion-window.service';
import { TesterWindowService } from '../services/tester-window.service';
import { UserActionService } from '../services/user-action.service';

// -----------------------------------------------------------------------------
// This is were we register all the external services - i.e. services we want
// other windows to be able to access (yet not have to create an actual
// instance for them).
@registry([
  {
    token: kNameOfPromotionWindowService,
    useFactory: instancePerContainerCachingFactory<IPromotionWindowService>(
      (c) => {
        return c.resolve(PromotionWindowService);
      },
    ),
  },
  {
    token: kNameOfTesterWindowService,
    useFactory: instancePerContainerCachingFactory<ITesterWindowService>(
      (c) => {
        return c.resolve(TesterWindowService);
      },
    ),
  },
  {
    token: kNameOfUserActionService,
    useFactory: instancePerContainerCachingFactory<IUserActionService>((c) => {
      return c.resolve(UserActionService);
    }),
  },
  {
    token: kDITokenExternalService,
    useFactory: instancePerContainerCachingFactory<IExposableService>((c) => {
      return c.resolve(kNameOfPromotionWindowService);
    }),
  },
  {
    token: kDITokenExternalService,
    useFactory: instancePerContainerCachingFactory<IExposableService>((c) => {
      return c.resolve(kNameOfTesterWindowService);
    }),
  },
  {
    token: kDITokenExternalService,
    useFactory: instancePerContainerCachingFactory<IExposableService>((c) => {
      return c.resolve(kNameOfUserActionService);
    }),
  },
])
export class ExternalServicesRegistry {}
